<div class="flex flex-col gap-4">
  @for (entry of entries(); track entry) {
    <app-vsp-regulation-lookup [field]="entry" [index]="$index" />
  }
  @if (!state().disabled()) {
    <button
      type="button"
      class="self-start text-left text-sm font-semibold text-button-secondary-color hover:underline"
      data-testid="vsp-add-item"
      (click)="addItem()">
      + Add VSP item
    </button>
  }
</div>
